import { number, shape, string } from "prop-types";

import Points from "web/Layout/Common/Points";

import WalletIcon from "web/assets/icons/wallet.svg";

import classify from "web/classify";

import defaultClasses from "./customer.scss";

const NavigationPanelAdditionalCustomer = ({ classes, totalPoints }) => {
  return (
    <div className={classes.root}>
      <WalletIcon className={classes.icon} width={22} />
      <Points className={classes.points} points={totalPoints} />
    </div>
  );
};

NavigationPanelAdditionalCustomer.propTypes = {
  classes: shape({
    root: string,
    icon: string,
    points: string,
  }).isRequired,
  totalPoints: number.isRequired,
};

export default classify(defaultClasses)(NavigationPanelAdditionalCustomer);
